export class FileUpload {
  id: number;
  name: string;
  url: string;
  file: string;
}
